import styled from 'styled-components'
import tokens from '@gympass/yoga-tokens'

import Container from '@components/Container'
import getBreakpoint from '@client/utils/breakpoints'

export const MainWrapper = styled.main`
  height: 1400px;

  @media (min-width: ${getBreakpoint('md')}px) {
    height: 980px;
  }
`

export const CardWrapper = styled(Container)`
  position: absolute;
  top: 72px;
  left: 0;
  right: 0;
`

export const HeaderWrapper = styled.header`
  padding-top: 8px;
  background-color: var(--white);
  height: 244px;
  box-sizing: border-box;
`

export const FormWrapper = styled.section`
  background: #ffffff;
  box-shadow: 0px 2px 6px rgba(152, 152, 166, 0.25);
  border-radius: 8px;
  padding: 16px 24px;
  margin-top: 64px;

  @media (min-width: ${getBreakpoint('md')}px) {
    padding: 16px 60px;
  }
`
export const FormTitle = styled.h1`
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: left;
  margin: 16px 0 0;
  color: #001027;

  @media (min-width: ${getBreakpoint('md')}px) {
    margin: 40px 0 0;
    font-size: 32px;
    line-height: 38px;
  }
`

export const FormSubtitle = styled.h2`
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  margin: 24px 0 40px;
  color: ${tokens.colors.deep};
  @media (min-width: ${getBreakpoint('md')}px) {
    margin: 16px 0 48px;
  }
`

export const FormFooter = styled.h2`
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: smaller;
  line-height: 24px;
  text-align: left;
  margin: 24px 0 40px;

  @media (min-width: ${getBreakpoint('md')}px) {
    margin: 16px 0 48px;
  }
`
